// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ojOS","messages":"Chat_messages__2Y7Wi","dateDivider":"Chat_dateDivider__252DM"};